"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.preload = void 0;

var _react = _interopRequireWildcard(require("react"));

var _CurrencyContext = _interopRequireDefault(require("./CurrencyContext"));

var _CurrencyConvert = require("./CurrencyConvert");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function reducer(state, action) {
  var payload = action.payload;

  switch (action.type) {
    case 'setFromCurrencyCode':
      return state.fromCurrencyCode === payload ? state : _objectSpread(_objectSpread({}, state), {}, {
        fromCurrencyCode: payload
      });

    case 'setToCurrencyCode':
      return state.toCurrencyCode === payload ? state : _objectSpread(_objectSpread({}, state), {}, {
        toCurrencyCode: payload
      });

    case 'setRateLoading':
      return state.rateLoading === payload ? state : _objectSpread(_objectSpread({}, state), {}, {
        rateLoading: payload
      });

    case 'setLang':
      return state.lang === payload ? state : _objectSpread(_objectSpread({}, state), {}, {
        lang: payload
      });

    case 'setRateData':
      return state.rateData === payload ? state : _objectSpread(_objectSpread({}, state), {}, {
        rateData: payload
      });
    // 用于csr获取汇率数据时

    case 'getRateDataCallback':
      return _objectSpread(_objectSpread({}, state), {}, {
        rateData: payload.rateData,
        rateLoading: payload.rateLoading
      });

    default:
      throw new Error();
  }
} // 地址信息Provider


var CurrencyHelper = function CurrencyHelper(_ref) {
  var children = _ref.children,
      fromCurrencyCode = _ref.fromCurrencyCode,
      lang = _ref.lang,
      toCurrencyCode = _ref.toCurrencyCode,
      _ref$supportMulti = _ref.supportMulti,
      supportMulti = _ref$supportMulti === void 0 ? false : _ref$supportMulti,
      currencyCode = _ref.currencyCode,
      rateDataSource = _ref.rateDataSource;

  var _useReducer = (0, _react.useReducer)(reducer, {
    rateLoading: false,
    fromCurrencyCode: fromCurrencyCode,
    lang: lang,
    toCurrencyCode: toCurrencyCode,
    rateData: rateDataSource !== null && rateDataSource !== void 0 ? rateDataSource : null
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var rateLoading = state.rateLoading,
      rateData = state.rateData;
  (0, _react.useEffect)(function () {
    if (supportMulti) {
      if (rateLoading || rateData) {
        // 正在加载或者有数据 直接停止
        return;
      } // 加载汇率数据


      dispatch({
        type: 'setRateLoading',
        payload: true
      });
      (0, _CurrencyConvert.getCurrencyRate)().then(function (res) {
        dispatch({
          type: 'getRateDataCallback',
          payload: {
            rateData: res,
            rateLoading: false
          }
        });
      });
    }
  }, [rateLoading, rateData, supportMulti]);
  (0, _react.useEffect)(function () {
    dispatch({
      type: 'setFromCurrencyCode',
      payload: fromCurrencyCode
    });
    dispatch({
      type: 'setToCurrencyCode',
      payload: toCurrencyCode
    });
    dispatch({
      type: 'setLang',
      payload: lang
    });
  }, [fromCurrencyCode, lang, toCurrencyCode]); // 监听dataSource 变化

  (0, _react.useEffect)(function () {
    dispatch({
      type: 'setRateData',
      payload: rateDataSource
    });
  }, [rateDataSource]);
  var currencyInfo = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, state), {}, {
      /**
       * 兼容旧版本
       */
      currencyCode: currencyCode,
      dispatch: dispatch
    });
  }, [state, currencyCode, dispatch]);
  return /*#__PURE__*/_react["default"].createElement(_CurrencyContext["default"].Provider, {
    value: currencyInfo
  }, children);
};
/**
 * ssr 预请求数据
 */


var preload = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
    var rateData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _CurrencyConvert.getCurrencyRate)(options);

          case 2:
            rateData = _context.sent;
            return _context.abrupt("return", {
              rateData: rateData
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preload(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.preload = preload;
var _default = CurrencyHelper;
exports["default"] = _default;